<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
// import { useProfileStore } from '@/stores/profile'
import { useEcusStore } from '@/stores/ecus'
import { useEcusDiagStore } from '@/stores/ecus-diag'

import tippy                from 'tippy.js' 
import Modal                from '@/components/UTAModal.vue'
// import UTAEcusExport        from '@/components/car/ecus/UTAEcusExport.vue'
import UTAEcusTiles         from '@/components/car/ecus/UTAEcusTiles.vue'
import UTAEcusDescr         from '@/components/car/ecus/UTAEcusDescr.vue'
// import checkArrayIncludes   from '@/helpers/checkArrayIncludes'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const translaterStore  = useTranslaterStore()
// const profileStore  = useProfileStore()
const ecusStore     = useEcusStore()
const ecusDiagStore = useEcusDiagStore()

// const showExportReport  = ref(false)
const showEcusStatus    = ref(false)

const getTranslate      = computed(() => translaterStore.getTranslate)
// const profile           = computed(() => profileStore.profile)
const ecus              = computed(() => ecusStore.ecus)
const ecusMsg           = computed(() => ecusStore.ecusMsg)
// const hasReport         = computed(() => ecusStore.hasReport)
const diagRunMsg        = computed(() => ecusDiagStore.diagRunMsg)
const diagRunProcess    = computed(() => ecusDiagStore.diagRunProcess)

// Считаем активные и пассивные ошибки в блоках
const ecusList = computed(() => {

    let ecusLocal = { ...ecus.value }

    for (let key in ecusLocal) {

        let item = ecusLocal[key]
        let active = 0
        let passive = 0

        // Для окрашивания блока в красный, нужно значение 1 в свойствах:
        // - Warning indicator requested (поле "WIR" в JSON)
        // - Test failed (поле "TF" в JSON)
        let wir = false

        if(item.report.val.length > 0) {
            active = item.report.val.filter(el => el.flags.TF === 1).length
            passive = item.report.val.length - active
            wir = item.report.val.some(el => {
                return el.flags.WIR === 1 && el.flags.TF === 1
            })
        }

        item.errors = { active, passive, wir }
    }

    return ecusLocal
})

onMounted(() => {
    document.addEventListener('mouseover', e => {
        if(e.target.classList.contains('has-tooltip')) {
            tippy('#' + e.target.id, {
                content: e.target.dataset.name,
            })
        }
    })
})

onBeforeUnmount(() => {
    ecusDiagStore.setDiagRunMsg({})
})
</script>

<template>

    <header class="page__header uta-header" role="heading" aria-level="1">
        <h1 class="uta-header__title">{{ getTranslate.CAR_ECUS }}</h1>
        <div class="uta-header__actions">
            <button
                href="#" 
                class="uta-header__action uta-btn uta-btn--sm uta-btn--has-icon"
                :disabled="diagRunProcess"
                @click="ecusDiagStore.runDiag({ 
                    uuid: props.uuid, 
                    diag: {
                        ecu: 'ALL_BLOCK_UAZ'
                    }
                })"
            >
                <div class="uta-btn__content">
                    <span class="uta-btn__icon material-icons">
                        refresh
                    </span>
                    <div class="uta-btn__text uta-btn__text--has-icon d-none d-sm-block">{{ getTranslate.CAR_ECUS_REFRESH }}</div>
                </div>
            </button>
            <!-- <button
                type="button"
                class="uta-header__action uta-btn uta-btn--sm uta-btn--has-icon"
                :disabled="!hasReport"
                @click="showExportReport = true"
                v-if="
                    checkArrayIncludes(profile.attr?.array, ['DIAGNOSTIC', 'SUPER_ADMIN']) && 
                    ecusMsg.success
                "
            >
                <div class="uta-btn__content">
                    <span class="material-icons uta-btn__icon">
                        file_download
                    </span>
                    <div class="uta-btn__text uta-btn__text--has-icon d-none d-sm-block">{{ getTranslate.CAR_ECUS_EXPORT }}</div>
                </div>
            </button> -->
        </div>
    </header>

    <div class="page__content uta-car-ecus-list">

        <div 
            v-if="'success' in diagRunMsg"
            class="mb-4 uta-alert uta-car-ecus-list__message"
            :class="{
                'uta-alert--success': diagRunMsg.success,
                'uta-alert--danger': !diagRunMsg.success
            }"
        >
            <span class="material-icons uta-alert__icon">
                {{ diagRunMsg.success ? 'check_circle_outline' : 'error_outline' }}
            </span>
            <span class="uta-alert__text">
                {{ getTranslate[diagRunMsg.text] || diagRunMsg.text }}
            </span>
            <button type="button" class="uta-alert__close" @click="ecusDiagStore.setDiagRunMsg({})">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div 
            v-if="'success' in ecusMsg && !ecusMsg.success"
            class="mb-4 uta-alert uta-alert--danger uta-car-ecus-list__message"
        >
            <span class="material-icons uta-alert__icon">
                error_outline
            </span>
            <span class="uta-alert__text">
                {{ getTranslate[ecusMsg.text] || ecusMsg.text }}
            </span>
        </div>

        <UTAEcusTiles :uuid="props.uuid" :ecusList="ecusList"/>

        <div class="uta-btns">
            <a href="#" @click.prevent="showEcusStatus = true" class="uta-btn uta-btn--sm my-5 uta-car-ecus__additional">{{ getTranslate.CAR_ECUS_ADDITIONAL }}</a>
        </div>

        <!-- <transition name="bounce">
            <Modal 
                v-if="showExportReport"
                :header="getTranslate.ECU_EXPORT"
                size="lgf"
                @closeModal="showExportReport = false"
            >
                <template v-slot:body>
                    <UTAEcusExport :uuid="props.uuid" @closeModal="showExportReport = false" />
                </template>
            </Modal>
        </transition> -->

        <transition name="bounce">
            <Modal 
                v-if="showEcusStatus"
                :header="getTranslate.CAR_ECUS_ADDITIONAL"
                size="md"
                @closeModal="showEcusStatus = false"
            >
                <template v-slot:body>
                    <UTAEcusDescr />
                </template>
            </Modal>
        </transition>

    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/ecus/ecus-list.scss';
@import '@/assets/styles/scss/components/car/ecus/ecus-link.scss';
</style>